// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1909":"3978708c","5457":"7489ce19","7103":"66630dc6","8109":"66630dc6"}[chunkId] + ".chunk.css";
};